import { gql } from 'apollo-angular';
import { Task } from '../../shared/entities/task/task';

export const OPERATED_RENTAL_TASK_QUERY = gql`
query getTask($id: UUID) {
  task: getTask(id: $id) {
    id
    description
    state
    taskType {
      code
      name
      prefix
      icon
      color
    }
    dueDateTimePeriod {
      modifier
      dateTime
      fromDateTime
      toDateTime
      precision
    }
    completedBy {
      id
      firstName
      lastName
    }
    assignment {
      assigneeId
      assignmentType
      typeLabel
      name
      dueDateTimePeriod {
        modifier
        dateTime
        fromDateTime
        toDateTime
      }
    }
    order{
      id
      number
      type
      customer {
        id
        type
        companyName
        companyNameExtension
        firstName
        lastName
      }
      location {
        name
      }
    }
    completedDateTime
    protocol {
      id
      type
      state
      completedDateTime
      completedBy {
        firstName
        lastName
      }
      formControlTemplate
      task {
        id
        taskType {
          code
          name
          prefix
          icon
          color
        }
        completedBy {
          firstName
          lastName
        }
        assignment {
          assigneeId
          assignmentType
          typeLabel
          name
          dueDateTimePeriod {
            modifier
            dateTime
            fromDateTime
            toDateTime
          }
        }
      }
    }
  }
}
`;


export interface OperatedRentalQuery {
  task: Task;
}


